import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px', fontFamily: 'system-ui, -apple-system, sans-serif', lineHeight: '1.6', color: '#333' }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '10px' }}>Privacy Policy</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>Last updated: {new Date().toLocaleDateString()}</p>

      <section style={{ marginBottom: '30px' }}>
        <h2>1. Introduction</h2>
        <p>Welcome to Smart Brain. This privacy policy explains how we collect, use, and protect your personal information when you use our mobile application and related services. Smart Brain is an educational platform designed for secondary school students in Nigeria.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>2. Information We Collect</h2>
        <p>We collect the following types of information when you use our app:</p>
        <ul>
          <li><strong>Personal Information:</strong> Email addresses and names provided during account creation.</li>
          <li><strong>Identifiers:</strong> Unique user IDs generated by our authentication system.</li>
          <li><strong>Usage Data:</strong> Information about how you interact with our lessons, quizzes, and features to improve our educational content.</li>
          <li><strong>Device Information:</strong> General information about your device, such as operating system and crash diagnostics, to ensure app stability.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>3. How We Use Your Information</h2>
        <p>We use the collected information for the following purposes:</p>
        <ul>
          <li>To provide, maintain, and improve the Smart Brain educational platform.</li>
          <li>To manage your account and track your learning progress.</li>
          <li>To communicate with you regarding updates, support, and administrative messages.</li>
          <li>To monitor the security and stability of our application.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>4. Third-Party Services</h2>
        <p>We use trusted third-party services to operate our app, including Google Firebase for authentication and database management. Your data is encrypted in transit and stored securely. We do not sell your personal information to advertisers or other third parties.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>5. Children's Privacy</h2>
        <p>Smart Brain is intended for secondary school students (typically ages 13 and above). We do not knowingly collect personal information from children under the age of 13 without parental consent. If you believe we have inadvertently collected such information, please contact us so we can delete it.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>6. Data Deletion and Your Rights</h2>
        <p>You have the right to request the deletion of your account and associated personal data. To request data deletion, you can either:</p>
        <ul>
          <li>Use the "Delete Account" feature within the Smart Brain mobile application (if available).</li>
          <li>Contact our support team directly via email.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>7. Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
      </section>

      <section style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
        <h2>Contact Us</h2>
        <p>If you have any questions about this Privacy Policy or wish to request data deletion, please contact us at:</p>
        <p><strong>Email:</strong> smartbrainng@gmail.com</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
